module.exports = __webpack_public_path__ + "img/my-order.98c9d814.png";